module.exports = "/assets/data/a8baea6e56508120dfc573db3372fe9f-NR23.data.json";